import ProjectNamingSchemeConfig from './ProjectNamingSchemeConfig'

export default ProjectNamingSchemeConfig
